'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bolt';
var width = 448;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = 'M329.4 3.1c-5.9-4.3-14-4-19.6 .7l-288 240c-5.2 4.3-7.1 11.4-4.8 17.7S25.3 272 32 272l144.7 0c11.3 0 19.1 11.4 14.9 21.9L113.1 490.1c-2.7 6.8-.5 14.6 5.5 18.9s14 4 19.6-.7l288-240c5.2-4.3 7.1-11.4 4.8-17.7S422.7 240 416 240l-144.7 0c-11.3 0-19.1-11.4-14.9-21.9L334.9 21.9c2.7-6.8 .5-14.6-5.4-18.9zM299.5-8.6c11.3-9.4 27.4-9.9 39.3-1.3s16.3 24.2 10.9 37.8L271.3 224 416 224c13.5 0 25.5 8.4 30.1 21.1s.7 26.9-9.6 35.5l-288 240c-11.3 9.4-27.4 9.9-39.3 1.3s-16.3-24.2-10.9-37.8L176.7 288 32 288c-13.5 0-25.5-8.4-30.1-21.1l0 0c-4.6-12.7-.7-26.9 9.6-35.5l288-240z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;